"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _formSlice = require("../redux/slices/formSlice");
var _userenderscount = _interopRequireDefault(require("@hedtech/userenderscount"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FieldArray = function FieldArray(props) {
  var defaultValue = props.defaultValue,
    _props$ensureAtLeastO = props.ensureAtLeastOneItem,
    ensureAtLeastOneItem = _props$ensureAtLeastO === void 0 ? false : _props$ensureAtLeastO,
    name = props.name,
    minimumItems = props.minimumItems;
  (0, _userenderscount["default"])("FieldArray( ".concat(name, " )"));
  var dispatch = (0, _reactRedux.useDispatch)();
  var selector = (0, _react.useMemo)(function () {
    return function (state) {
      return (0, _lodash.get)(state.form.values, (0, _lodash.toPath)(name));
    };
  }, [name]);
  var state = (0, _reactRedux.useSelector)(selector, _reactRedux.shallowEqual);
  var add = (0, _react.useCallback)(function () {
    dispatch((0, _formSlice.addItemToValuesArray)({
      defaultValue: defaultValue,
      name: name
    }));
  }, [defaultValue, dispatch, name]);
  var addMinimumItems = (0, _react.useCallback)(function () {
    dispatch((0, _formSlice.addMinimumItemsToValuesArray)({
      defaultValue: defaultValue,
      name: name,
      minimumItems: minimumItems
    }));
  }, [defaultValue, dispatch, name, minimumItems]);
  (0, _react.useEffect)(function () {
    if (ensureAtLeastOneItem && (!state || state.length === 0)) {
      setTimeout(add, 1);
    }
    if (minimumItems && (!state || state.length < minimumItems)) {
      addMinimumItems();
    }
  }, [dispatch, add, ensureAtLeastOneItem, state, minimumItems, addMinimumItems]);
  var remove = (0, _react.useCallback)(function (index) {
    (0, _reactRedux.batch)(function () {
      dispatch((0, _formSlice.removeItemFromValueArray)({
        index: index,
        name: name
      }));
      dispatch((0, _formSlice.removeItemFromErrorsArray)({
        index: index,
        name: name
      }));
      dispatch((0, _formSlice.removeItemFromTouchedArray)({
        index: index,
        name: name
      }));
    });
  }, [dispatch, name]);
  return /*#__PURE__*/_react["default"].createElement("div", null, props.children(name, state, add, remove));
};
FieldArray.propTypes = {
  children: _propTypes["default"].func.isRequired,
  defaultValue: _propTypes["default"].any,
  ensureAtLeastOneItem: _propTypes["default"].bool,
  name: _propTypes["default"].string.isRequired,
  minimumItems: _propTypes["default"].number
};
var _default = exports["default"] = FieldArray;